import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaStore, FaLock, FaEnvelope, FaEye, FaEyeSlash, FaArrowLeft, FaShieldAlt, FaChartLine } from 'react-icons/fa';
import api from '../api';
import './FranchiseLogin.css';

export default function FranchiseLogin() {
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    if (error) setError(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      const response = await api.post('/getStoreOrders', {
        email: formData.email,
        password: formData.password
      });

      if (response.data?.status?.statusCode === 'code-200') {
        // Store login info in sessionStorage
        sessionStorage.setItem('franchiseEmail', formData.email);
        sessionStorage.setItem('franchisePassword', formData.password);
        navigate('/franchise/dashboard');
      } else if (response.data?.status?.statusCode === 'code-401') {
        setError('Invalid email or password. Please try again.');
      } else if (response.data?.status?.statusCode === 'code-404') {
        setError('Store not found. Please check your email address.');
      } else {
        setError('Login failed. Please try again.');
      }
    } catch (error) {
      console.error('Login error:', error);
      setError('Network error. Please check your connection and try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="franchise-login-wrapper_2">
      {/* Background Pattern */}
      <div className="background-pattern_2"></div>
      
      {/* Main Container */}
      <div className="franchise-login-container_2">
        {/* Left Side - Branding */}
        <div className="login-branding_2">
          <div className="branding-content_2">
            <button 
              className="back-navigation_2"
              onClick={() => navigate('/franchise')}
            >
              <FaArrowLeft />
              <span>Back to Franchise</span>
            </button>
            
            <div className="brand-logo_2">
              <div className="logo-icon_2">
                <FaStore />
              </div>
              <h1>Franchise Portal</h1>
              <p>Manage your store operations with ease</p>
            </div>

            <div className="features-list_2">
              <div className="feature-item_2">
                <FaChartLine className="feature-icon_2" />
                <span>Real-time Analytics</span>
              </div>
              <div className="feature-item_2">
                <FaShieldAlt className="feature-icon_2" />
                <span>Secure Dashboard</span>
              </div>
              <div className="feature-item_2">
                <FaStore className="feature-icon_2" />
                <span>Store Management</span>
              </div>
            </div>
          </div>
        </div>

        {/* Right Side - Login Form */}
        <div className="login-form-section_2">
          <div className="form-container_2">
            <div className="form-header_2">
              <h2>Welcome Back</h2>
              <p>Sign in to access your franchise dashboard</p>
            </div>

            <form className="login-form_2" onSubmit={handleSubmit}>
              <div className="form-field_2">
                <label htmlFor="email" className="field-label_2">
                  <FaEnvelope className="label-icon_2" />
                  Store Email Address
                </label>
                <div className="input-group_2">
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="Enter your store email"
                    required
                    disabled={loading}
                    className="form-input_2"
                  />
                </div>
              </div>

              <div className="form-field_2">
                <label htmlFor="password" className="field-label_2">
                  <FaLock className="label-icon_2" />
                  Password
                </label>
                <div className="input-group_2">
                  <input
                    type={showPassword ? 'text' : 'password'}
                    id="password"
                    name="password"
                    value={formData.password}
                    onChange={handleChange}
                    placeholder="Enter your password"
                    required
                    disabled={loading}
                    className="form-input_2"
                  />
                  <button
                    type="button"
                    className="password-toggle_2"
                    onClick={() => setShowPassword(!showPassword)}
                    disabled={loading}
                    aria-label={showPassword ? 'Hide password' : 'Show password'}
                  >
                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                  </button>
                </div>
              </div>

              {error && (
                <div className="error-message_2">
                  {error}
                </div>
              )}

              <button
                type="submit"
                className="login-button_2"
                disabled={loading || !formData.email || !formData.password}
              >
                {loading ? (
                  <>
                    <div className="spinner_2"></div>
                    Signing In...
                  </>
                ) : (
                  'Sign In to Dashboard'
                )}
              </button>
            </form>

            <div className="form-footer_2">
              <div className="divider-line_2">
                <span>or</span>
              </div>
              <div className="footer-content_2">
                <p>Don't have a franchise account?</p>
                <button 
                  className="register-link_2"
                  onClick={() => navigate('/franchise#form')}
                >
                  Apply for Franchise
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
